export const MIN_POINTS_PER_MESSAGE = 1
export const MAX_POINTS_PER_MESSAGE = 15
